export const APP_COOKIE_NAME = 'KVD-LOGIN-COOKIE';
export const SET_ESTABLISHMENT_DATA = 'SET_ESTABLISHMENT_DATA';
export const SET_MENU_DATA = 'SET_MENU_DATA';
export const SET_MAP_DATA = 'SET_MAP_DATA';
